"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
var paginateAnything_1 = require("../../../functions/util/paginateAnything");
exports.colors = paginateAnything_1.paginateAnything([
    {
        content: {
            value: "blue-green",
        },
        id: 1089102,
        source: "API",
        uniqueId: "blue-green",
    },
    {
        content: {
            value: "blueberry",
        },
        id: 1089101,
        source: "API",
        uniqueId: "blueberry",
    },
    {
        content: {
            value: "Blue",
        },
        id: 1190205,
        source: "API",
        uniqueId: "Blue",
    },
    {
        content: {
            value: "Green",
        },
        id: 1190204,
        source: "API",
        uniqueId: "Green",
    },
    {
        content: {
            value: "Orange",
        },
        id: 1190202,
        source: "API",
        uniqueId: "Orange",
    },
    {
        content: {
            value: "Purple",
        },
        id: 1190206,
        source: "API",
        uniqueId: "Purple",
    },
    {
        content: {
            value: "Red",
        },
        id: 1190201,
        source: "API",
        uniqueId: "Red",
    },
    {
        content: {
            value: "Violet",
        },
        id: 1190207,
        source: "API",
        uniqueId: "Violet",
    },
    {
        content: {
            value: "Yellow",
        },
        id: 1190203,
        source: "API",
        uniqueId: "Yellow",
    },
]);
//# sourceMappingURL=colors.js.map